import { Container, Header, Tabs } from "@amzn/awsui-components-react";
import PtcAnalysis from "./PtcAnalysis";
import PtcReplacer from "./PtcReplacer";
import UploadSnapshot from "./snapshot/UploadSnapshot";
import DownloadSnapshot from "./snapshot/DownloadSnapshot";
import enMessages from "@amzn/awsui-components-react/polaris/i18n/messages/all.en";
import { I18nProvider } from "@amzn/awsui-components-react/polaris/i18n";

export default function App() {
  return (
    <I18nProvider locale="en" messages={[enMessages]}>
      <Container header={<Header>Sales Tax Holiday Add-in</Header>}>
        <Tabs
          tabs={[
            {
              label: "PTC Analysis",
              id: "ptc_analysis",
              content: <PtcAnalysis />,
            },
            {
              label: "PTC Replacer",
              id: "ptc_replacer",
              content: <PtcReplacer />,
            },
            {
              label: "Take Snapshot",
              id: "takeSnapshot",
              content: <UploadSnapshot />,
            },
            {
              label: "Download Snapshot",
              id: "downloadSnapshot",
              content: <DownloadSnapshot />,
            },
          ]}
        />
      </Container>
    </I18nProvider>
  );
}
